import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from "react-router-dom";
import { TenantEventProvider } from "./TenantEventContext";
export var RouteParameterProvider = function (_a) {
    var children = _a.children;
    var _b = useParams(), tenantId = _b.tenantId, eventId = _b.eventId;
    console.log("RouteParameterProvider: tenantId=".concat(tenantId, ", eventId=").concat(eventId));
    return (_jsx(TenantEventProvider, { tenantId: tenantId ? tenantId : null, eventId: eventId ? eventId : null, children: children }));
};
